<template>
  <div class="my_container" :class="mobileOnOff ? 'mobile_container' : ''">
    <div v-if="!mobileOnOff" class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'MemberList' }">社区交流室</el-breadcrumb-item>
        <el-breadcrumb-item>{{detail.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if="!mobileOnOff">
      <div class="glag_left">
          <div class="text_detail_box">
            <div class="text_detail_title">
              <p>{{detail.title}}</p>
              <p class="text_detail_time">发布时间：{{detail.add_time}}</p>
              <p class="text_detail_tag">标签：
                <span v-for="item in detail.tag" :key="item.id">{{item.tag_name}}</span>
              </p>
            </div>
            <div v-if="childOnOff && detail.video_path.length > 0" class="text_detail_video">
              <video-view :src-arr="detail.video_path" :bg-img="detail.bg_img_path"></video-view>
            </div>
            <div class="text_detail_content" v-html="detail.content"></div>
            <div class="text_detail_files" v-if="detail.more.length > 0">
              <span>附件：</span>
              <div v-for="item in detail.more" :key="item.id" class="text_detail_files_item">
                <a :href="item.path">点击下载：{{item.name}}</a>
              </div>
            </div>
            <div class="text_detail_address" v-if="detail.type === '2'">
              <span>文章转载自：{{detail.address}}</span>
            </div>
            <div class="expert_list_other rt">
              <share-view :detail="detail"></share-view>
            </div>
          </div>
          <comment-view
          :comments = "comment"
          :list-id = "commentList.list_id"
          :user = "user"
          :mescount = "detail.mes_count"
          :participatecount = "detail.participate_count"
          ></comment-view>
      </div>
      <div class="glag_right">
        <recommend-view v-if="recommendList !== null" :list="recommendList"></recommend-view>
      </div>
    </div>
    <div v-else>
      <detail-mobile-view></detail-mobile-view>
    </div>
  </div>
</template>

<script>
import video from '../Public/video.vue'
import comment from '../Public/comment.vue'
import recommend from '../Public/detailRecommendList.vue'
import share from '../Public/share.vue'
import detailM from '../Mobile/detailM.vue'
export default {
  components: {
    videoView: video,
    commentView: comment,
    recommendView: recommend,
    shareView: share,
    detailMobileView: detailM
  },
  data () {
    return {
      mobileOnOff: false, // 判断是否为手机登录
      childOnOff: false, // 子组建渲染开关
      commentList: {
        list_id: ''
      },
      detail: {
        video_path: [],
        more: []
      }, // 文章详情
      user: {}, // 作者信息
      comment: {
        comments: []
      }, // 评论列表
      userFollow: false, // 关注开关
      dianzanOnOff: false, // 点赞开关
      shoucangOnOff: false, // 收藏开关
      recommendList: null, // 相关内容推荐
      shareOnOff: false // 分享弹窗开关
    }
  },
  created () {
    const vueThat = this
    // vueThat.mobileOnOff = vueThat.mycommon.judgeMobile()
    if (!vueThat.mobileOnOff) {
      console.log(vueThat.mobileOnOff)
      vueThat.commentList.list_id = vueThat.$route.query.id
      vueThat.myApi.communityMemberDetails(vueThat.commentList).then((res) => {
        if (res.data.code === 200) {
          vueThat.detail = res.data.data.data
          vueThat.childOnOff = true
          vueThat.comment.comments = res.data.data.mes_data
          vueThat.recommendList = res.data.data.right
          // 文章是否点赞
          if (vueThat.detail.is_like === 0) {
            vueThat.dianzanOnOff = false
          } else {
            vueThat.dianzanOnOff = true
          }
          // 文章是否收藏
          if (vueThat.detail.is_collection === 0) {
            vueThat.shoucangOnOff = false
          } else {
            vueThat.shoucangOnOff = true
          }
        }
      })
    }
  },
  methods: {
    // 相关内容跳转
    jump (rid, navId) {
      let path = ''
      if (navId === 8) {
        path = '/expertDetail/:id'
      }
      const routeData = this.$router.resolve({
        path: path,
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>
</style>
